class Forms {
	constructor() {
		let that = this;

		this.forms = $('.wpcf7');
		this.forms.each(function (index, elem) {

			// When clicking a form submit button :
			$(elem).find('.wpcf7-submit').on('click', function () {
				$(elem).addClass('loading');
			});

			// When the form validation fails or the mail fails to be sent :
			$(elem).on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7unaccepted', function () {
				$(elem).removeClass('loading');
			});

			// When the mail is successfully sent
			$(elem).on('wpcf7mailsent', function () {
				$(elem).removeClass('loading');
				$(elem).addClass('success');
				$(elem).append('<div class="form-success"><strong>Votre message a bien été envoyé.</strong>Nous vous contacterons dans les meilleurs délais.</div>');
				that.resetForm(elem);
			});
		});

		// Managing form inputs and labels focus and filled states :
		this.fields = $('.form__field input:not([type="file"]), .form__field--textarea textarea, .form__field--select select');
		this.fields.each(function (index, elem) {
			let $inputContainer = $(elem).closest('.form__container');
			$(elem).on('focus', function () {
				$inputContainer.addClass('active');
			}).on('blur', function () {
				$inputContainer.removeClass('active');

				if ($(elem).val() === "") {
					$inputContainer.removeClass('filled');
				} else {
					$inputContainer.addClass('filled');
				}
			});
		});

		// Managing input files
		this.fileuploads = $('.form__container--file');
		this.fileuploads.each(function (index, elem) {
			let $inputContainer = $(elem),
				$input = $(elem).find('input[type="file"]'),
				$responseContainer = $(elem).find('.form__value'),
				responseValue = $responseContainer.html();

			$responseContainer.on('click', function () {
				$input.trigger('click');
			});
			$input.on('change', function (e) {
				let fileName = e.target.value.split('\\').pop();

				if (fileName) {
					$responseContainer.html(fileName);
					$inputContainer.addClass('filled');
				} else {
					$responseContainer.html(responseValue);
					$inputContainer.removeClass('filled');
				}
			});

			// Firefox bug fix
			$input
				.on('focus', function () {
					$input.addClass('has-focus');
				})
				.on('blur', function () {
					$input.removeClass('has-focus');
				});
		});
	}

	resetForm(elem) {
		setTimeout(function() {
			$(elem).removeClass('success');
			body.removeClass('program-forms-is-opened card-form-is-opened');
			$(elem).find('.form__container').removeClass('filled');
			$(elem).find('input[type="reset"]').click();
			$(elem).find('.form-success').remove();
		}, 4000);
	}
}
